import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import LandingPage from './components/LandingPage';
import QuestionList from './components/QuestionList';
import GeneratePaper from './components/GeneratePaper';
import QuestionSelector from './components/QuestionSelector';
import ModeSelectionPage from './components/ModeSelectionPage';
import Layout from './components/Layout';
import About from './components/About';
import Contact from './components/Contact';
import Login from './pages/Login';
import Signup from './pages/Signup';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './App.css';

window.history.scrollRestoration = 'manual';

function App() {

  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  useEffect(() => {
    const syncUser = () => {
      setCurrentUser(
        JSON.parse(localStorage.getItem("user"))
      );
    };

    window.addEventListener("storage", syncUser);

    return () => {
      window.removeEventListener("storage", syncUser);
    };
  }, []);

  return (
    <div className="app-container">
      <Router>
        <ScrollToTop />
        <Routes>
		
          {/* Legal pages (work in new tab) */}
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          <Route
            path="/login"
            element={
              <Login
                onLoginSuccess={(user) => {
                  localStorage.setItem("user", JSON.stringify(user));
                  setCurrentUser(user);
                }}
              />
            }
          />

          <Route
            path="/signup"
            element={
              <Signup
                onLoginSuccess={(user) => {
                  localStorage.setItem("user", JSON.stringify(user));
                  setCurrentUser(user);
                }}
              />
            }
          />

          <Route
            path="/"
            element={<Layout user={currentUser} setUser={setCurrentUser} />}
          >
            <Route index element={<LandingPage />} />
            <Route path="mode" element={<ModeSelectionPage />} />
            <Route path="select" element={<QuestionSelector />} />
            <Route path="questions" element={<QuestionList />} />
            <Route path="generate" element={<GeneratePaper />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
          </Route>

        </Routes>
      </Router>
    </div>
  );
}
export default App;

